<template>
  <b-sidebar
    :id="sbId"
    :visible="sbModel"
    sidebar-class="border-right border-danger"
    right
    shadow
    lazy
    :no-header="true"
  >
    <contact-form-card @add-contact-click="handleAddContactClick" />
    <template #footer>
      <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto">{{ userDataContactsLastUpdated }}</strong>
        <b-button size="sm" @click="handleCloseSideBar">Close </b-button>
      </div>
    </template>
    <div></div>
  </b-sidebar>
</template>
<script>
import { mapGetters } from "vuex";
import UploadImage from "@/mixins/UploadImage";
import ImageUpload from "@/components/common/imageUpload";
import ContactFormCard from "./contactFormCard";
import Editor from "@/components/common/editor";
import moment from "moment";
export default {
  name: "CallLog_AddContacts_Sidebar",
  mixins: [UploadImage],
  components: {
    ImageUpload,
    ContactFormCard,
    Editor
  },
  props: {
    sbId: {
      type: String,
      required: true
    },
    sbModel: {
      type: Boolean,
      required: true
    },
    resource: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      apps: "user/apps",
      userData: "user/appsData",
      user: "user/user",
      profile: "user/profile"
    }),
    /* DATA */
    userDataContactsLastUpdated() {
      let timeMsg = "";
      if (this.userData && this.userData && this.userData._updated_at) {
        const date = this.userData._updated_at;
        const time = moment(new Date(date.toDate())).format("MM/DD/YYYY");
        timeMsg = `Last update was ${time}`;
      }
      return timeMsg;
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleAddContactClick(newContact) {
      this.$emit("add-contact-click", newContact);
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.$emit("close-clicked");
    },
    handleAddNoteTogggle() {
      this.addNote = !this.addNote;
    },
    resetClear() {
      this.clear = false;
    },
    handleSlidingStart(numberSlidingTo) {},
    handleSlidingEnd(numberSlidTp) {
      //Pause slide to play audio

      if (this.settings_autoPlayPhotoAudio) {
        let thePhoto =
          this.userDataPhotos.length > numberSlidTp
            ? this.userDataPhotos[numberSlidTp]
            : null;
        if (thePhoto.audioURL) {
          this.handlePlayAudio(thePhoto.audioURL);
        }
      }
    }
  },
  data() {
    return {
      production: false,
      selectedContact: null,
      isCompany: true,
      idx: 0,
      docs: [],
      addNote: false,
      msgs: [
        "A photo is worth a thousand words",
        "A Photo is a memory saved",
        "Nice Photo"
      ],
      storagePath: "app_call_log_contacts",
      clear: "",
      search: "",
      name: "",
      /* SLIDE INFO*/
      /* SLIDE INFO*/
      slideId: "contacts-slide",
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      interval: 0,
      transition: false,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.btn-add-contact {
  cursor: pointer;
  background: var(--theme-color);
  border-radius: 8px;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 27px;
  color: #fff;
  border: none;
  height: 50px;
  width: 100%;
}
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
.black-placeholder::-webkit-input-placeholder {
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.optional2 {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  p {
    margin-left: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #474d52;
    margin: 0;
    margin-left: 16px;

    span {
      padding-left: 8px;
    }
  }
}
.toggler {
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  background: #f3f6f9;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  cursor: pointer;
  @media (max-width: 590px) {
    margin-left: 15px;
  }
}
.slider {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #b3c2cb;
  box-shadow: 0px 3px 9px #c4c4c4;

  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}
.bg {
  background: rgba(85, 126, 251, 0.1);
}
.btns {
  left: 50%;
  background: var(--theme-color);
  box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
}
</style>
